export const environment = {
    production: true,
       firebaseConfig: {
        apiKey: "AIzaSyBwUKjVvDS66F6pApIpSw-ilSw9uLl8Qyg",
        authDomain: "galaxy-pynt-3f50b.firebaseapp.com",
        projectId: "galaxy-pynt-3f50b",
        storageBucket: "galaxy-pynt-3f50b.firebasestorage.app",
        messagingSenderId: "480774253394",
        appId: "1:480774253394:web:39f7109f1474af52d6a88b",
        measurementId: "G-NN5HQNJ21R",
        vapidKey: "BOJyTFWx9Y6s489dlxZjOToTb-ihB4Aim2IuT3NyX3EXXqlwGMFRzcNTp2IxZpSKTac3SJ69k-Lb2_BLBUey5Zk"
    }
};
